const consent_common = {
  methods: {
    COM_signatureInfo() {
      return this.consent.signer ? this.COM_signature() : '';
    },
    COM_signature() {
      return this.i18nJS.consents.edit.signed_consent_info
        .replace('___DATE___', this.consent.date)
        .replace('___SIGNER___', this.consent.signer);
    },
  },
};

export { consent_common };
